import { useEffect } from "react";
import { initPushNotifications } from "../utils/pushNotifications";
import { requestBatteryOptimizationExemption } from "../utils/batteryOptimization";
import { initDeepLinks } from "../utils/deepLinks";

// Registra el token de push para CUALQUIER usuario, tenga sesión o no — un dispositivo
// sin login queda como AnonymousDevice en el backend, para poder mandarle promociones
// de marketing igual (más interactividad sin exigir cuenta). Cuando el usuario inicia
// sesión, este efecto se re-dispara (cambia user?.id) y ese mismo token pasa a
// User.fcmToken, limpiándose del lado anónimo — ver authService.updateFcmToken.
// Antes esto solo pasaba logueado, y encima solo para company/ryder.
export default function PushRegistrar() {
  const user = (() => {
    try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
  })();

  useEffect(() => { initDeepLinks(); }, []);

  useEffect(() => {
    initPushNotifications();
    // La excepción de batería solo se pide con sesión iniciada, no a un dispositivo
    // anónimo que apenas abrió la app.
    if (user?.id) requestBatteryOptimizationExemption();
    // eslint-disable-next-line
  }, [user?.id]);

  return null;
}
